import { createSlice } from "@reduxjs/toolkit";
import reducers from "./reducers";
import { ProductGridState } from "./types";

export const initialState: ProductGridState = {
  selectedState: {},
  shouldShowAttribution: false,
};
const productGridSlice = createSlice({
  name: "productGrid",
  initialState,
  reducers,
});

const { actions } = productGridSlice;
export { actions };

export default productGridSlice;
